import request from "../utils/request";

export async function getExpenseList(payload) {
  return request.get("Expense/List", {
    params: {
      sortBy: payload.sortBy,
      sortDirection: payload.sortDirection,
      pageIndex: payload.pageIndex,
      pageSize: payload.pageSize,
      description: payload.expenseDescription != null ? payload.expenseDescription.name : null,
      minPrice: payload.price != null ? payload.price.min : null,
      maxPrice: payload.price != null ? payload.price.max : null,
      expenseDefinitionId: payload.expenseDefinition != null ? payload.expenseDefinition.id : null,
      personalId: payload.personal != null ? payload.personal.id : null,
      branchId: payload.branch != null && payload.branch !== 'undefined' && payload.branch.id > 0 ? payload.branch.id : null,
      paymentMethodId: payload.paymentMethod != null ? payload.paymentMethod.id : null,
      startDate: payload.dateRange != null && payload.dateRange.startDate != null ? payload.dateRange.startDate.toDateString() : null,
      startTime: payload.timeRange != null && payload.timeRange.startTime != null ? payload.timeRange.startTime.HH + ':' + payload.timeRange.startTime.mm : null,
      endDate: payload.dateRange != null && payload.dateRange.endDate != null ? payload.dateRange.endDate.toDateString() : null,
      endTime: payload.timeRange != null && payload.timeRange.endTime != null ? payload.timeRange.endTime.HH + ':' + payload.timeRange.endTime.mm : null,
    }
  });
}

export async function getExpenseListForDealer(payload) {
  return request.get("Expense/ListForDealer", {
    params: {
      sortBy: payload.sortBy,
      sortDirection: payload.sortDirection,
      pageIndex: payload.pageIndex,
      pageSize: payload.pageSize,
      description: payload.expenseDescription != null ? payload.expenseDescription.name : null,
      minPrice: payload.price != null ? payload.price.min : null,
      maxPrice: payload.price != null ? payload.price.max : null,
      expenseDefinitionId: payload.expenseDefinition != null ? payload.expenseDefinition.id : null,
      personalId: payload.personal != null ? payload.personal.id : null,
      branchId: payload.branch != null && payload.branch !== 'undefined' && payload.branch.id > 0 ? payload.branch.id : null,
      paymentMethodId: payload.paymentMethod != null ? payload.paymentMethod.id : null,
      startDate: payload.dateRange != null && payload.dateRange.startDate != null ? payload.dateRange.startDate.toDateString() : null,
      startTime: payload.timeRange != null && payload.timeRange.startTime != null ? payload.timeRange.startTime.HH + ':' + payload.timeRange.startTime.mm : null,
      endDate: payload.dateRange != null && payload.dateRange.endDate != null ? payload.dateRange.endDate.toDateString() : null,
      endTime: payload.timeRange != null && payload.timeRange.endTime != null ? payload.timeRange.endTime.HH + ':' + payload.timeRange.endTime.mm : null,
    }
  });
}

export async function getExcel(payload) {
  return request.get("Expense/GetExcel", {
    responseType: 'blob',
    headers: {
      'Accept': 'application/vnd.ms-excel'
    },
    params: {
      sortBy: payload.sortBy,
      sortDirection: payload.sortDirection,
      pageIndex: payload.pageIndex,
      pageSize: payload.pageSize,
      description: payload.expenseDescription != null ? payload.expenseDescription.name : null,
      minPrice: payload.price != null ? payload.price.min : null,
      maxPrice: payload.price != null ? payload.price.max : null,
      expenseDefinitionId: payload.expenseDefinition != null ? payload.expenseDefinition.id : null,
      personalId: payload.personal != null ? payload.personal.id : null,
      branchId: payload.branch != null && payload.branch != undefined && payload.branch.id > 0 ? payload.branch.id : null,
      paymentMethodId: payload.paymentMethod != null ? payload.paymentMethod.id : null,
      startDate: payload.dateRange != null && payload.dateRange.startDate != null ? payload.dateRange.startDate.toDateString() : null,
      startTime: payload.timeRange != null && payload.timeRange.startTime != null ? payload.timeRange.startTime.HH + ':' + payload.timeRange.startTime.mm : null,
      endDate: payload.dateRange != null && payload.dateRange.endDate != null ? payload.dateRange.endDate.toDateString() : null,
      endTime: payload.timeRange != null && payload.timeRange.endTime != null ? payload.timeRange.endTime.HH + ':' + payload.timeRange.endTime.mm : null,
    }
  })
}

export async function createNewExpense(newExpense) {
  return request.post("Expense/Create", newExpense);
}

export async function updateExpense(expense) {
  return request.post("Expense/Update", expense);
}

export async function deleteExpense(id) {
  return request.delete('Expense/Delete?id=' + id);
}
